// Paleta del tema Desaturado.
//
// Autosuficiente: declara TODOS los nombres semánticos que rules.js
// referencia. El generador falla si falta alguno (principio 4.3 del
// paquete AJUSTE-PALETA-MARKERS). Los overrides son opcionales y
// deben declarar `razón` para pasar la validación.

export default {
  meta: {
    id: 'desaturado',
    nombre: 'Desaturado',
    descripcion: 'Tema por defecto, tonos suaves, contraste medio para pantallas estándar de C4/C5',
    modo: 'claro',
  },

  paleta: {
    // Patrulla (devices tipo policía)
    'patrulla-normal':         '#185FA5',
    'patrulla-atenuado':       '#85B7EB',

    // Cámara
    'camara-normal':           '#5DCAA5',
    'camara-atenuado':         '#9FE1CB',
    // Ámbito de la cámara (placa/borde bajo el marker + leyenda del filtro
    // del toolbar). No los referencia rules.js — son tokens de runtime
    // leídos por layer-manager (anillo) y MapToolbar (--kln-marker-*).
    // Armonía sobre camara-normal (#5DCAA5, H157°): análogo frío + triádico
    // cálido, ambos desaturados. El complementario puro (rosa H337°) se
    // evita a propósito — colisiona con la semántica de alerta del mapa.
    // Violeta profundo elegido por el stakeholder (jul 2026): equivale a
    // softenHex('#4A148C') — el mismo render que el override custom que
    // le gustó en el mapa. Los tokens de paleta no pasan por softenHex,
    // por eso se guarda ya armonizado.
    'camara-estatal':          '#5C3290',   // violeta profundo (split-complementary)
    // Naranja elegido por el stakeholder (jul 2026): softenHex('#F4511E'),
    // guardado ya armonizado igual que camara-estatal.
    'camara-municipal':        '#CF6543',   // naranja quemado
    'camara-otro':             '#77808C',   // gris azulado tenue (privadas/eventos)

    // LPR (analíticos)
    'lpr-normal':              '#534AB7',
    'lpr-atenuado':            '#AFA9EC',

    // Bus (transporte público)
    'bus-normal':              '#639922',
    'bus-atenuado':            '#C0DD97',

    // Sensor (botón de pánico)
    'sensor-standby':          '#EF9F27',   // ámbar, "armado esperando"
    'sensor-alerta':           '#E24B4A',   // rojo saturado, "alerta activa"

    // Incidente 911 — color base (fallback) y modulación por prioridad
    'incidente-activo':        '#E24B4A',
    'incidente-baja':          '#F09595',

    // Categorías CNIE v3.0 (cada grupo con su color distintivo; el halo
    // rojo alrededor del marker sigue comunicando "es un incidente", el
    // color del fondo del icono distingue la categoría)
    // Familia cromática del manual oficial federal del C5/911 — cada
    // categoría toma su tono del manual (verde médico, azul seguridad,
    // amarillo PC, morado servicios públicos, naranja asistencia, gris
    // otros, rojo mal uso) ajustado al rango medio/desaturado del tema.
    'cat-seguridad':           '#5489D6',   // azul (policía/federal)
    'cat-medico':              '#5BA86E',   // verde sanitario
    'cat-proteccion-civil':    '#E0B22D',   // amarillo dorado puro (separado de asistencia)
    'cat-servicios-publicos':  '#8A6FCC',   // morado institucional
    'cat-asistencia':          '#D77236',   // naranja-rojizo (separado de PC)
    'cat-otros-servicios':     '#5F6B7A',   // gris oscuro
    'cat-mal-uso':             '#D14B4B',   // rojo (advertencia mal uso)

    // Devices por tipo operativo (sistema custom MapV2 — paridad con
    // incidentes-CNIE pero para unidades). Color del container distingue
    // corporación; el ícono interno comunica el vehículo.
    'device-policia-municipal-normal':    '#185FA5',   // azul medio (consistencia con patrulla)
    'device-policia-municipal-atenuado':  '#85B7EB',
    'device-policia-estatal-normal':      '#0D3F75',   // azul más oscuro
    'device-policia-estatal-atenuado':    '#7AA3CB',
    'device-policia-ministerial-normal':  '#7548A0',   // violeta investigación
    'device-policia-ministerial-atenuado':'#BFA1D9',
    'device-gn-normal':                   '#A37828',   // dorado militar (compartido con kpiPcivil-tono)
    'device-gn-atenuado':                 '#D9BE7C',
    'device-transito-normal':             '#C76E1F',   // naranja vialidad
    'device-transito-atenuado':           '#EAB387',
    'device-ambulancia-normal':           '#C84573',   // rosa-magenta médico (kpiMedico vibe)
    'device-ambulancia-atenuado':         '#EAA5BC',
    'device-bomberos-normal':             '#B73523',   // rojo bombero (más profundo que alert)
    'device-bomberos-atenuado':           '#E48E80',
    'device-proteccion-civil-normal':     '#D9A348',   // ámbar PC (mismo que cat-proteccion-civil)
    'device-proteccion-civil-atenuado':   '#EFD09B',
    'device-transporte-publico-normal':   '#3D7A2F',   // verde transporte (consistencia con bus-normal)
    'device-transporte-publico-atenuado': '#9CC58C',
    'device-funcionario-normal':          '#3F7A7B',   // teal apagado administrativo
    'device-funcionario-atenuado':        '#A0C4C5',
    'device-dron-normal':                 '#7A4FD0',   // violeta-magenta UAV
    'device-dron-atenuado':               '#C0A9E5',
    'device-otros-normal':                '#5F6B7A',   // gris neutro fallback
    'device-otros-atenuado':              '#B0B7C0',

    // External device (GPS de terceros / flotas privadas). Familia propia,
    // NO 'patrulla' — ver comentario en rules.js. Deriva de --kln-entity-violet
    // (#A87DD0, src/themes/system-b.js — reservado, invariante entre temas,
    // ya usado por esta entidad en chips/toolbar/ENTITY_COLORS/icon-registry).
    // H=271° (hue de entity-violet) fijo entre los 4 temas; S/L tomados
    // literalmente del par patrulla-normal/patrulla-atenuado de este tema
    // (S75/L37 y S72/L72) — mismo "peso" visual/contraste que la familia
    // que reemplaza, solo cambia el matiz. Distancia RGB resultante a
    // patrulla-normal: 102; a device-dron-normal: 74; a camara-estatal: 34.
    'external-device-normal':             '#6118A5',
    'external-device-atenuado':           '#B984EB',

    // SOS
    'sos-esperando':           '#D4537E',
    'sos-en-progreso':         '#D4537E',
    'sos-finalizado':          '#ED93B1',

    // Neutrales transversales
    'neutro-apagado':          '#888780',
    'neutro-texto-oscuro':     '#2C2C2A',
    'neutro-texto-claro':      '#FFFFFF',
  },

  overrides: {},
}
